<section class="urc-card">
	<h1 class="title">{{ title }}</h1>
	<ng-content></ng-content>
</section>
